import axios from '@/utils/request'
// 看板上方的数据统计
export function boardTopValues(params) {
  const boardTopValues = axios({
    url: '/patrolBoard/boardTopValues',
    method: 'get',
    params
  })
  return boardTopValues
}
// 看板左侧事件类型统计
export function eventTypeStatistics(params) {
  const eventTypeStatistics = axios({
    url: '/patrolBoard/eventTypeStatistics',
    method: 'get',
    params
  })
  return eventTypeStatistics
}
// 看板左下巡检总里程（今日）
export function todayTotalMileage(params) {
  const todayTotalMileage = axios({
    url: '/patrolBoard/todayTotalMileage',
    method: 'get',
    params
  })
  return todayTotalMileage
}
// 看板右侧正常异常对比
export function normalErrorCompare(params) {
  const normalErrorCompare = axios({
    url: '/patrolBoard/normalErrorCompare',
    method: 'get',
    params
  })
  return normalErrorCompare
}

// 看板左侧事件类型统计(近7日内) 计算好百分比的接口
export function eventTypeStatisticsPercent(params) {
  const eventTypeStatisticsPercent = axios({
    url: '/patrolBoard/eventTypeStatisticsPercent',
    method: 'get',
    params
  })
  return eventTypeStatisticsPercent
}

// 管线巡检完成率
export function lineCompletionRate(params) {
  const lineCompletionRate = axios({
    url: '/patrolBoard/lineCompletionRate',
    method: 'get',
    params
  })
  return lineCompletionRate
}
